import { EmployeeFormatConfiguration } from 'nomst/Stores/Configuration/employeeFormatConfiguration';
import { EmployeeNameFormat } from 'typings/enums';

export class EmployeeConfiguration {
    formatConfiguration: EmployeeFormatConfiguration;

    constructor(format: EmployeeFormatConfiguration) {
        this.formatConfiguration = new EmployeeFormatConfiguration(
            format?._employeeNameSortFormat ?? EmployeeNameFormat.FirstNameLastName);
    }
}